import { HIDE_MESSAGE, HIDE_MESSAGE_SUCCESS, HIDE_MESSAGE_ERROR, HIDE_MESSAGE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const HideMessage = (state = initialState, action) => {
  switch (action.type) {
    case HIDE_MESSAGE:
      state = { ...state, loading: true, success: false, error: false, message: null };
      break;
    case HIDE_MESSAGE_SUCCESS:
      state = { ...state, data: action.payload, loading: false, success: true, error: false };
      break;
    case HIDE_MESSAGE_ERROR:
      state = { ...state, data: null, loading: false, success: false, error: true, message: action.payload };
      break;
    case HIDE_MESSAGE_EMPTY:
      state = { ...initialState };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default HideMessage;
